import { HTMLAttributes, memo, PropsWithChildren, ReactNode } from 'react';
import cls from 'classnames';

import styles from './Button.module.scss';

interface ButtonProps extends HTMLAttributes<HTMLButtonElement> {
  className?: string;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
}

function Button(props: PropsWithChildren<ButtonProps>) {
  const { className, startIcon, endIcon, children, ...rest } = props;

  const hasStartIcon = Boolean(startIcon);
  const hasEndIcon = Boolean(endIcon);
  const hasChildren = Boolean(children);

  return (
    <button
      className={cls(
        styles.button,
        {
          [styles.buttonIconLeft]: hasStartIcon,
          [styles.buttonIconRight]: hasEndIcon,
        },
        className,
      )}
      {...rest}
    >
      {hasStartIcon && startIcon}

      {hasChildren && <span>{children}</span>}

      {hasEndIcon && <span>{endIcon}</span>}
    </button>
  );
}

export default memo(Button);
